import accommodationMarketingSchema from './marketingSchema';
import translationSchema from '../translationSchema';

const accommodationCreationSchema = accommodationMarketingSchema.concat(translationSchema.required);

export default accommodationCreationSchema;
